/**
 * Notify Me
 * Renders the Notify Me page and manages the notification bubble.
 */
console.log('✅ notify-me.js loaded');

const STORAGE_KEY = 'tinkedge_notify_me';

function getSavedItems() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function removeItem(variantId) {
  const items = getSavedItems().filter((i) => i.variant_id !== variantId);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  document.dispatchEvent(new CustomEvent('notify-me:updated'));
}

function updateNotifyBubble() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const count = Array.isArray(list) ? list.length : 0;
    const bubble = document.getElementById('notify-bubble');
    if (!bubble) return;
    const countEl = bubble.querySelector('.notify-bubble__count');
    countEl.textContent = count > 99 ? '99+' : count > 0 ? String(count) : '';
    bubble.classList.toggle('notify-bubble--visible', count > 0);
  } catch (e) {}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateNotifyBubble);
} else {
  updateNotifyBubble();
}

document.addEventListener('notify-me:updated', updateNotifyBubble);
document.addEventListener('shopify:section:load', updateNotifyBubble);
window.addEventListener('storage', (e) => {
  if (e.key === STORAGE_KEY) updateNotifyBubble();
});

function saveItem(item) {
  const items = getSavedItems();
  const exists = items.find((i) => i.variant_id === item.variant_id);
  if (!exists) {
    items.push(item);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('notify-me:updated'));
  }
}

function showSavedNotification(productTitle, alreadySaved = false) {
  const existing = document.getElementById('nm-notification');
  if (existing) existing.remove();

  const note = document.createElement('div');
  note.id = 'nm-notification';
  note.innerHTML = alreadySaved
    ? `<span>Already in your <a href="/pages/notify-me-page">Notify Me</a> list!</span>`
    : `<span>🔔 We'll notify you when <strong>${productTitle}</strong> is back! <a href="/pages/notify-me-page">View list</a></span>`;
  note.style.cssText = `
    position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
    background: #111; color: #fff; padding: 12px 20px; border-radius: 8px;
    z-index: 9999; font-size: 14px; box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    white-space: nowrap;
  `;
  note.querySelectorAll('a').forEach((a) => (a.style.cssText = 'color: #aef; text-decoration: underline;'));
  document.body.appendChild(note);
  setTimeout(() => note.remove(), 4000);
}

// Handle bell button clicks on product cards
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.notify-me-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const { variantId, productTitle, productUrl, productImage } = btn.dataset;
  if (!variantId) return;

  const alreadySaved = !!getSavedItems().find((i) => i.variant_id === variantId);
  if (alreadySaved) {
    showSavedNotification('', true);
    return;
  }

  saveItem({
    variant_id: variantId,
    title: productTitle,
    url: productUrl,
    image: productImage,
    saved_at: new Date().toISOString(),
  });

  btn.classList.add('notify-me-btn--saved');
  showSavedNotification(productTitle, false);
});

// Mark already-saved buttons on page load
function markSavedButtons() {
  const saved = getSavedItems().map((i) => i.variant_id);
  document.querySelectorAll('.notify-me-btn').forEach((btn) => {
    if (saved.includes(btn.dataset.variantId)) {
      btn.classList.add('notify-me-btn--saved');
    }
  });
}

document.addEventListener('DOMContentLoaded', markSavedButtons);

// Render notify-me page if on that page
document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('nm-grid');
  if (!grid) return;

  const items = getSavedItems();
  const emptyMsg = document.getElementById('nm-empty');

  if (items.length === 0) {
    if (emptyMsg) emptyMsg.style.display = 'block';
    return;
  }

  items.forEach((item) => {
  const card = document.createElement('div');
  card.className = 'wishlist-page__card';
  card.innerHTML = `
    <a href="${item.url}" class="wishlist-page__card-link">
      <div class="wishlist-page__card-image">
        ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
      </div>
      <div class="wishlist-page__card-info">
        <p class="wishlist-page__card-title">${item.title}</p>
        <p class="wishlist-page__card-date">Requested on ${new Date(item.saved_at).toLocaleDateString()}</p>
        <span class="nm-card__stock-badge" data-variant="${item.variant_id}"></span>
      </div>
    </a>
    <button
      class="wishlist-page__remove button"
      data-variant-id="${item.variant_id}"
    >
      Remove
    </button>
  `;
  grid.appendChild(card);

  // Remove button handler
  card.querySelector('.wishlist-page__remove').addEventListener('click', (e) => {
    removeItem(item.variant_id);
    card.remove();
    document.dispatchEvent(new CustomEvent('notify-me:updated'));
    if (getSavedItems().length === 0 && emptyMsg) emptyMsg.style.display = 'block';
  });

  // Live stock check
  fetch(`${item.url}.js`)
    .then((r) => r.json())
    .then((product) => {
      const variant = product.variants?.find((v) => String(v.id) === String(item.variant_id));
      const badge = card.querySelector('.nm-card__stock-badge');
      if (!badge) return;
      if (variant?.available) {
        badge.textContent = '✅ Back in stock!';
        badge.style.cssText = 'color: green; font-weight: 600; font-size: 0.85rem; display: block; margin-top: 4px;';
      } else {
        badge.textContent = 'Out of stock';
        badge.style.cssText = 'color: #999; font-size: 0.85rem; display: block; margin-top: 4px;';
      }
    })
    .catch(() => {});
  });
  
  grid.querySelectorAll('.nm-remove-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      removeItem(btn.dataset.variantId);
      btn.closest('.nm-card').remove();
      if (getSavedItems().length === 0 && emptyMsg) emptyMsg.style.display = 'block';
    });
  });
});
